import React from 'react';
import {
  Drawer,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Divider,
  Box,
} from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { featureFlag } from '../../featureFlags';
import { LanguageSwitcher } from '../../translation/tools/LanguageSwitcher';

interface AppBarNavigationDrawerMobileProps {
  mobileOpen: boolean | undefined;
  drawerNavigationItems: any;
  handleDrawerMobileToggle?: () => void;
}

export function AppBarNavigationDrawerMobile({
  mobileOpen,
  handleDrawerMobileToggle,
  drawerNavigationItems,
}: AppBarNavigationDrawerMobileProps) {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { t } = useTranslation();

  const menuAction = (link: string) => {
    navigate(link);
    if (handleDrawerMobileToggle) handleDrawerMobileToggle();
  };

  return (
    <Box
      component="nav"
      sx={{ width: { sm: 240 }, flexShrink: { sm: 0 } }}
      aria-label={t('accessibility.MOBILE_MENU')}
    >
      <Drawer
        variant="temporary"
        open={mobileOpen}
        onClose={handleDrawerMobileToggle}
        ModalProps={{
          keepMounted: true,
        }}
        sx={{
          display: { xs: 'block', sm: 'none' },
          '& .MuiDrawer-paper': { boxSizing: 'border-box', width: 240 },
        }}
      >
        <Divider />
        <List sx={{ mt: 6 }}>
          {drawerNavigationItems.map((item: any) => {
            return (
              <Box key={item.text}>
                <ListItemButton
                  aria-label={item.text?.toLowerCase()}
                  data-testid={item.text?.toLowerCase()}
                  onClick={() => menuAction(item.link)}
                  sx={{ p: 2 }}
                  selected={pathname.includes(item.link)}
                >
                  {item.icon && <ListItemIcon>{item.icon}</ListItemIcon>}
                  <ListItemText primary={item.text} />
                </ListItemButton>
                {item.withDivider && <Divider />}
              </Box>
            );
          })}
        </List>
        {featureFlag('languageSwitcher') && <LanguageSwitcher />}
      </Drawer>
    </Box>
  );
}
